export const CANCEL_SUBSCRIPTION = 'CANCEL_SUBSCRIPTION'
